import { render, staticRenderFns } from "./AgregarMacheoClipboard.vue?vue&type=template&id=5b44242d"
import script from "./AgregarMacheoClipboard.vue?vue&type=script&lang=js"
export * from "./AgregarMacheoClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports